import React from "react";
import { Box, Container, Typography, IconButton, Tooltip } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TelegramIcon from "@mui/icons-material/Telegram";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

import logo from "../assets/images/logo footer.png";
import xLogo from "../assets/images/x-logo.png";

const UI = {
  ridge:
    "linear-gradient(90deg," +
    "rgba(56,189,248,0) 0%," +
    "rgba(56,189,248,.18) 18%," +
    "rgba(255,255,255,.16) 50%," +
    "rgba(20,241,149,.18) 82%," +
    "rgba(20,241,149,0) 100%)",
  


  // ✅ тёмный фон футера (чтобы ничего не сливалось)
  bg: "linear-gradient(180deg, rgba(2,6,23,.92) 0%, rgba(2,6,23,.98) 100%)",
  borderTop: "1px solid rgba(255,255,255,.08)",
  text: "#e5e7eb",
  sub: "rgba(148,163,184,.92)",

  // ✅ иконки как раньше, но под тёмный фон -> светлые
  icon: "#e5e7eb",
  iconHover: "#ffffff",

  // ✅ кнопки без овалов, аккуратно
  btnBg: "rgba(255,255,255,.03)",
  btnBgHover: "rgba(255,255,255,.07)",
  btnBorder: "1px solid rgba(255,255,255,.10)",
  btnBorderHover: "1px solid rgba(255,255,255,.18)",
};

const SIZES = {
  BTN: 40,
  BTN_X: 58, // ✅ как у тебя (больше под X)
  ICON: 24,
  GAP: 1,
  R: 10, // ✅ меньше округление (не овалы)
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        background: UI.bg,
        borderTop: UI.borderTop,
      }}
    >
      <Container maxWidth="lg" sx={{ pt: { xs: 1, sm: 1.25 }, pb: { xs: 1, sm: 1.25 } }}>
        {/* ✅ твоя верхняя полоса (тонкая) */}
       <Box
  aria-hidden
  sx={{
    height: 8, // было 6 — чуть толще, иначе теряется
    mb: 1,
    background: UI.ridge,
    borderRadius: 999,

    // ✅ делаем “видимой” на чёрном
    boxShadow:
      "0 0 0 1px rgba(255,255,255,.06), 0 10px 34px rgba(56,189,248,.18), 0 10px 34px rgba(20,241,149,.14)",
    opacity: 0.95,

    // ✅ рассеивание по бокам (но не убиваем середину)
    maskImage:
      "radial-gradient(170% 120% at 50% 50%, #000 62%, rgba(0,0,0,.65) 78%, transparent 100%)",
    WebkitMaskImage:
      "radial-gradient(170% 120% at 50% 50%, #000 62%, rgba(0,0,0,.65) 78%, transparent 100%)",
  }}
/>
        {/* нижняя строка */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "auto 1fr auto" },
            alignItems: "center",
            gap: { xs: 1, sm: 1.25 },
          }}
        >
          {/* Left: logo + name */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifySelf: { xs: "center", sm: "start" },
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="PromosPay"
              sx={{
                height: 30,
                width: "auto",
                objectFit: "contain",
                display: "block",
                filter: "drop-shadow(0 10px 20px rgba(0,0,0,.45))",
              }}
            />

            <Typography
              variant="subtitle1"
              sx={{
                color: UI.text,
                fontFamily: "'Bruno Ace SC', sans-serif",
                fontWeight: 800,
                letterSpacing: ".06em",
                textTransform: "uppercase",
              }}
            >
              PromosPay
            </Typography>
          </Box>

          <Box />

          {/* Right: icons (как у тебя), только под тёмный фон */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: SIZES.GAP,
              justifySelf: { xs: "center", sm: "end" },
            }}
          >
            <Tooltip title="Email">
              <IconButton
                component="a"
                href="mailto:promospayai@gmail.com"
                sx={{
                  p: 0,
                  width: SIZES.BTN,
                  height: SIZES.BTN,
                  borderRadius: `${SIZES.R}px`,
                  background: UI.btnBg,
                  border: UI.btnBorder,
                  "&:hover": { background: UI.btnBgHover, border: UI.btnBorderHover },
                }}
              >
                <MailOutlineIcon sx={{ fontSize: SIZES.ICON, color: UI.icon }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Docs">
              <IconButton
                component="a"
                href="https://docs.promospay.ai"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  p: 0,
                  width: SIZES.BTN,
                  height: SIZES.BTN,
                  borderRadius: `${SIZES.R}px`,
                  background: UI.btnBg,
                  border: UI.btnBorder,
                  "&:hover": { background: UI.btnBgHover, border: UI.btnBorderHover },
                }}
              >
                <DescriptionOutlinedIcon sx={{ fontSize: SIZES.ICON, color: UI.icon }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="X (Twitter)">
              <IconButton
                component="a"
                href="https://x.com/promospay"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  p: 0,
                  width: SIZES.BTN_X,
                  height: SIZES.BTN_X,
                  borderRadius: `${SIZES.R}px`,
                  background: UI.btnBg,
                  border: UI.btnBorder,
                  "&:hover": { background: UI.btnBgHover, border: UI.btnBorderHover },
                }}
              >
                <Box
                  component="img"
                  src={xLogo}
                  alt="X"
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "block",
                    // ✅ если твой xLogo тёмный — делаем видимым на тёмном фоне
                    filter: "invert(1)",
                    opacity: 0.92,
                  }}
                />
              </IconButton>
            </Tooltip>

            <Tooltip title="YouTube">
              <IconButton
                component="a"
                href="https://youtube.com/@PROMOSPAY"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  p: 0,
                  width: SIZES.BTN,
                  height: SIZES.BTN,
                  borderRadius: `${SIZES.R}px`,
                  background: UI.btnBg,
                  border: UI.btnBorder,
                  "&:hover": { background: UI.btnBgHover, border: UI.btnBorderHover },
                }}
              >
                <YouTubeIcon sx={{ fontSize: SIZES.ICON, color: UI.icon }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Telegram">
              <IconButton
                component="a"
                href="https://t.me/your_channel"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  p: 0,
                  width: SIZES.BTN,
                  height: SIZES.BTN,
                  borderRadius: `${SIZES.R}px`,
                  background: UI.btnBg,
                  border: UI.btnBorder,
                  "&:hover": { background: UI.btnBgHover, border: UI.btnBorderHover },
                }}
              >
                <TelegramIcon sx={{ fontSize: SIZES.ICON, color: UI.icon }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Box sx={{ mt: 0.6, textAlign: "center" }}>
          <Typography variant="caption" sx={{ color: UI.sub, fontFamily: "'Bruno Ace SC', sans-serif" }}>
            © {year} PromosPay
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

